module.exports = "<div data-watermark data-watermark-<%=position %>><img src=\"<%= imageUrl %>\"></div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/plugins/watermark/public/watermark.html
 ** module id = 149
 ** module chunks = 0
 **/